module.exports = __webpack_public_path__ + "images/tips/power-ups-1@1x.d7178bb1e5dc48fb4fe6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/power-ups-1@1x.png
// module id = DeK3
// module chunks = 0